var path = 'C:/programming/work/gitlab/ez-web-toolkit/src/components/colorPicker/colorPicker.html';
var html = "<div class=\"ui labeled button\">\r\n        <button \r\n        class=\"ui fluid basic button\"\r\n        colorpicker type=\"button\" \r\n        colorpicker-position=\"top\" \r\n        ng-model=\"cp.color\">\r\n        {{cp.text}}\r\n    </button>\r\n    <a class=\"ui basic left pointing label\" ng-style=\"{'background-color': cp.color}\"></a>\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngtemplate-loader!./node_modules/html-loader!./src/components/colorPicker/colorPicker.html
// module id = 60
// module chunks = 0